var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',[_c('img',{attrs:{"src":"/bundles/wordpress.svg","height":"16"}}),void 0],2)}
var staticRenderFns = []

export { render, staticRenderFns }